import nodeClient from "./node-client";

export const searchCategories = async () => {
  const response = await nodeClient.get(`/service/private/v0/list/category`);
  return response.data;
};
